import { useEffect, useState } from 'react';
import Modal from '../Modal';

type Props = {
  minWidth: number;
  minHeight: number;
  absoluteMinWidth?: number;
};

export default function ResolutionBlocker({ minWidth, minHeight, absoluteMinWidth = 900 }: Props) {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setBlocked(
        window.innerWidth < minWidth || window.innerHeight < minHeight || window.innerWidth < absoluteMinWidth
      );
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Modal
      isOpen={blocked}
      title="Din skärm är för liten"
      onClose={window.innerWidth >= absoluteMinWidth ? () => setBlocked(false) : undefined}
      onAction={window.innerWidth >= absoluteMinWidth ? () => setBlocked(false) : undefined}
      actionText="OK"
    >
      <p>
        Partnerportalen är optimerad för en skärmstorlek på minst <strong>1280x720</strong> pixlar. En mindre skärm kan
        påverka både utseende och funktionalitet. För bästa upplevelse, använd en större skärm.
      </p>
    </Modal>
  );
}
